// src/constants/tenantStatus.ts
export const TENANT_STATUSES = ['ACTIVE', 'SUSPENDED', 'TERMINATED', 'DELETED'];